import { useEffect, useRef } from 'react';
import { useAppSelector } from './redux';

/**
 * Hook that triggers a callback when the user's current organization changes
 * @param callback Function to call when organization changes
 * @param dependencies Optional dependencies array (like useEffect)
 */
export const useOrganizationChange = (
  callback: () => void | Promise<void>,
  dependencies: any[] = []
) => {
  const { user } = useAppSelector((state) => state.auth);
  const previousOrgId = useRef<string | undefined>(user?.currentOrganizationId);

  useEffect(() => {
    const currentOrgId = user?.currentOrganizationId;
    
    // If organization changed (and it's not the initial load)
    if (previousOrgId.current !== undefined && previousOrgId.current !== currentOrgId) {
      callback();
    }
    
    // Update the ref for next comparison
    previousOrgId.current = currentOrgId;
  }, [user?.currentOrganizationId, ...dependencies]);

  // Return whether this is an organization change (not initial load)
  return {
    isOrgChange: previousOrgId.current !== undefined && previousOrgId.current !== user?.currentOrganizationId
  };
};
